import * as React from 'react'

type Props = {
  width?: number
  height?: number
}
const Icon = (props: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 600 600"
    // style={{
    //   enableBackground: 'new 0 0 600 600',
    // }}
    {...props}
    xmlSpace="preserve"
  >
    <linearGradient
      id="a"
      gradientUnits="userSpaceOnUse"
      x1={46.9}
      y1={300.5}
      x2={553.1}
      y2={300.5}
    >
      <stop
        offset={0}
        style={{
          stopColor: '#00f899',
        }}
      />
      <stop
        offset={1}
        style={{
          stopColor: '#00a9f6',
        }}
      />
    </linearGradient>
    <path
      d="M534.4 30.8 300 166.1 65.6 30.8c-8.3 4.8-10.4 6-18.7 10.8v159.9l95.9 55.4 42.1 24.3H220l42.1-24.3 231.5-133.6v78.3l-146.4 84.5-25 14.4 25 14.4 146.4 84.5v78.3L262 344.1l-42.1-24.3h-35.1l-42.1 24.3-95.9 55.4v159.9c8.3 4.8 10.4 6 18.7 10.8L300 434.9l234.3 135.3c8.3-4.8 10.4-6 18.7-10.8V399.5l-171.4-99 171.4-99V41.6c-8.2-4.8-10.3-6-18.6-10.8zm-332 191.7-95.9-55.4V88.8l163.7 94.5-67.8 39.2zm-95.9 289.7v-78.3l95.9-55.4 67.8 39.2-163.7 94.5z"
      style={{
        fill: 'url(#a)',
      }}
    />
  </svg>
)

export default Icon
